module.exports = __webpack_public_path__ + "static/media/patrol(23).b9cf51b5.PNG";